<template>
    <router-view class="main" />
</template>
<script>
import requsetURL from '../public/defaultRequest.js';
export default {
    data() {
        return {
            token: '',
            time: '',
            ip: '',
            downloadData: [] // 导出文件列表的数据， 要求实现全局监听，无论在哪个菜单，只要文件状态变为copy就提示
        };
    },
    async created() {
        let temp = `${requsetURL}/api/basic/auth/login?serviceUrl=${window.location.origin}`;
        await this.getUrl();
        if (!this.token) {
            window.location.replace(temp);
        } else if (sessionStorage.getItem('currentPath') && sessionStorage.getItem('currentPath') != 'null') {
            this.$router.push({ name: sessionStorage.getItem('currentPath') });
        } else {
            this.$router.push({
                path: '/homePage',
                query: {}
            });
        }
    },
    mounted() {
        this.getUserIP(ip => {
            this.ip = ip;
            // sessionStorage.setItem('ip',this.ip) // 在index.html调用搜狐的链接
        });
    },

    methods: {
        getUrl(type) {
            let idArray = window.location.search.split('=');
            this.token = idArray[1];
            sessionStorage.setItem('token', JSON.stringify(this.token));
            // if (!this.token) return

            if (sessionStorage.getItem('currentPath') && sessionStorage.getItem('currentPath') != 'null') {
                this.$router.push({ name: sessionStorage.getItem('currentPath') });
                //   return false
            } else {
                this.$router.push({
                    path: '/homePage',
                    query: {}
                });
            }
        },
        getUserIP(onNewIP) {
            let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;

            let pc = new MyPeerConnection({
                iceServers: []
            });

            let noop = () => {};

            let localIPs = {};

            let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;

            let iterateIP = ip => {
                if (!localIPs[ip]) onNewIP(ip);

                localIPs[ip] = true;
            };

            pc.createDataChannel('');

            pc.createOffer()
                .then(sdp => {
                    sdp.sdp.split('\n').forEach(function (line) {
                        if (line.indexOf('candidate') < 0) return;

                        line.match(ipRegex).forEach(iterateIP);
                    });

                    pc.setLocalDescription(sdp, noop, noop);
                })
                .catch(reason => {});

            pc.onicecandidate = ice => {
                if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;

                ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
            };
        }
    }
};
</script>
<style lang="css">
.el-form-item__content {
	height: 40px;
}
.el-form-item__error {
	color: #f5222d;
	font-size: 12px;
	line-height: 0;
	position: absolute;
	top: 100%;
	left: 0;
}
.el-table-filter {
	max-height: 300px;
	overflow: auto;
}
</style>
